import React from 'react';
import CategoryLandingPage from './CategoryLandingPage';
import { nyeConfig } from '../configs/categoryLandings';

export default function NyeLandingPage() {
  return <CategoryLandingPage config={nyeConfig} />;
}
